import { useRouter } from 'next/router';
import NoSsr from '@common/noSsr';
import { FindStateType, ModalStateType } from '@components/loginModal';
import ResumeLogin from './resumeLogin';
import MyPageLogin from './myPageLogin';
import { JobflexQuery } from '@domain/constant/JobflexQueryType';

interface LoginProps {
  setModalState: (state: ModalStateType) => void;
  setFindState: (state: FindStateType) => void;
}

const Login = ({ setModalState, setFindState }: LoginProps) => {
  const router = useRouter();
  const {
    query: { type },
  } = router;
  const isJobFlexResume = type === JobflexQuery.resume;
  const isJobFlexMyPage = type === JobflexQuery.mypage;

  return (
    //SocialLogin 컴포넌트에서 location 접근 시 발생하는 에러를 해결하기 위해 사용
    <NoSsr>
      {isJobFlexMyPage && <MyPageLogin setFindState={setFindState} setModalState={setModalState} />}
      {isJobFlexResume && <ResumeLogin setFindState={setFindState} setModalState={setModalState} />}
    </NoSsr>
  );
};

export default Login;
